export default "__VITE_ASSET__B30VUGwV__"